import { AdminAccountService, ListingModalService, BookService } from '@DavisDigital/davisdigitalfrontend.module';

enum Action {
	NOOP,
	DELETE,
	UNLOCK,
	LOCK,
	RESET,
	SAVE
}

//maps back to keys of Action
enum PreAction {
	PRE_DELETE = "DELETE",
	PRE_RESET = "RESET"
}

class DistrictUsersController {
	public actionOptions: any[];
	public actionModel;
	public loading = true;
	public accountUpdateLoading:Action;
	public districtAccount:any;
	public assignedLicenses:any;
	public licenseLookup:any;
	public removeLicenses = [];
	public PreAction = PreAction; //for access in view
	public Action = Action; //for access in view
	private _actionToTake:Action|PreAction = Action.NOOP;//should never be set directly, use this.actionToTake instead (setter/getter method)
	public formFields = [
		{
			display: 'First Name',
			property: 'firstName',
			type: 'text',
			validators: {required:true}
		},		
		{
			display: 'Last Name',
			property: 'lastName',
			type: 'text',
			validators: {required:true}
		},
		{
			display: 'Email Address',
			property: 'emailAddress',
			type: 'email',
			validators: {required:true, minLength: 5, match: {property: 'emailAddressConfirm', display:'Email Address Confirm'}}
		},
		{
			display: 'User Name',
			property: 'username',
			type: 'text',
			validators: {required:true, maxLength: 25}
		},
		{
			display: 'Account Role',
			property: 'accountType',
			type: 'select',
			options: [{display:'Student', property: 'Student'}, {display:'District Admin', property: 'Admin'}, {display:'Faculty', property: 'Faculty'}],
			validators: {required:true},
			defaultValue: 'Student'
		},
		{
			display: 'Status',
			property: 'status',
			type: 'text',
			readonly: true,
		},
		{
			display: 'District Name',
			property: 'districtName',
			type: 'text',
			readonly: true,
		},
	];
	public showModal = false;
	public formObj = {
		entity: 'account',
		accountID: ''
	};
	
	// @ngInject
	constructor(
		private adminAccountService:AdminAccountService,
		private $location,
		private listingModalService : ListingModalService,
		private davisAlertService,
		private bookService : BookService
	){

	}
	
	public isSampleBook = (bookCode) => this.bookService.isSampleBook(bookCode);
	
	public $onInit = () =>{
		this.loadAccountInformation();
	}

	
	private loadAccountInformation = () => {
		
		this.loading = true;
		let accountID = this.$location.search().accountID;
		
		this.removeLicenses = [];
		this.assignedLicenses = [];
		
		this.adminAccountService.getAccountAndLicenseInfo(accountID).then(result=>{
			
			
			this.districtAccount = result.data.data.account;
			this.districtAccount['accountID'] = accountID;
			
			//initialize form properties
			this.formObj['firstName'] = this.districtAccount.firstName;
			this.formObj['lastName'] = this.districtAccount.lastName;
			this.formObj['emailAddress'] = this.districtAccount.emailAddress;
			this.formObj['username'] = this.districtAccount.username;
			this.formObj['status'] = this.districtAccount.status;
			this.formObj['districtName'] = this.districtAccount.districtName;
			this.formObj['accountType'] = this.districtAccount.role;
			
			this.assignedLicenses = result.data.data.licenses;
			this.licenseLookup = result.data.data.licenseLookup
			
			this.actionOptions = [
				{
					'name': 'Select an action',
					'value': this.Action.NOOP
				},
				{
					'name': 'Delete Account',
					'value': this.PreAction.PRE_DELETE
				}
			]
			
			if(this.districtAccount.status.toLowerCase().trim() == 'inactive'){
				this.actionOptions.push(
					{
						'name': 'Unlock Account',
						'value': this.Action.UNLOCK
					}
				);
			}
			
			if(this.districtAccount.status.toLowerCase().trim() == 'active'){
				this.actionOptions.push(
					{
						'name': 'Lock Account',
						'value': this.Action.LOCK
					}
				);	
			}
			
			this.actionOptions.push(
				{
					'name': 'Reset Password',
					'value': this.PreAction.PRE_RESET
				}
			);
			
			this.actionOptions.push(
				{
					'name': 'Update Account',
					'value': this.Action.SAVE
				}
			);
			
			this.actionModel = this.actionOptions[0]['value'];
			
		}).finally(() => {
			this.loading = false;
		});
	}
	
	/**
	 * Method to handle grant license checkbox click
	*/
	public toggleRemoveLicenses(baseObjectID):void{
		if(this.removeLicenses.indexOf(baseObjectID) > -1){
			this.removeLicenses.splice(this.removeLicenses.indexOf(baseObjectID), 1);
		}else{
			this.removeLicenses.push(baseObjectID);
		}
		
		//this.grantLicenses.join()
	}
	
	/**
	 * Method to show license confirm modal
	 * */
	public onRemoveLicense = () => {
		let licenses = [];
		//prepare license array
		for(let license in this.assignedLicenses) {
			license = this.assignedLicenses[license];
			if( this.removeLicenses.indexOf(license['bookID']) > -1) {
				licenses.push(license);
			}
		}
		
		if( licenses.length <= 0) {
			this.davisAlertService.error('Please select licenses.');
			return;
		}
		
		this.listingModalService.launchDeleteLicenseModal( `${this.formObj['firstName']} ${this.formObj['lastName']}`,
				licenses,
        (confirmDelete) => {
            if(confirmDelete){
            	this.removeLicensesForAccount();
            }
        });
	}
	
	/**
	 * Method to remove license for account
	 **/
	private removeLicensesForAccount = () => {
		this.loading = true;
		this.adminAccountService.removeLicensesForAccount(this.removeLicenses.join(), this.$location.search().accountID).then(res => {
			if( res.data.successfulActions.length ) {
				this.loadAccountInformation();
			}
			
		}).finally(() => {
			this.loading = false;
		});
	}
	
	/**
	 * Method to show reassign license modal
	 * */
	public onReassignLicense = () => {
		let licenses = [];
		
		//prepare license array
		for(let license in this.assignedLicenses) {
			license = this.assignedLicenses[license];
			if( this.removeLicenses.indexOf(license['bookID']) > -1) {
				licenses.push(license);
			}
		}
		
		if( licenses.length <= 0) {
			this.davisAlertService.error('Please select licenses.');
			return;
		}
		
		this.listingModalService.launchReassignLicenseModal(
			`${this.formObj['firstName']} ${this.formObj['lastName']}`,
			this.$location.search().accountID,
				licenses,
        () => {
            this.loadAccountInformation();
        });
		
	}
	
	public set actionToTake(val:Action|PreAction){
		val = isNaN(parseInt( val as string )) ? val :  parseInt(val as string);
		
		this._actionToTake = val;
		
		console.log('actionToTake', this._actionToTake);
	
		//IF val === Type of PreAction => show modal - Else IF val === Type of Action => execute action
		if(val === PreAction.PRE_DELETE || val === PreAction.PRE_RESET){
			this.showModal = true;
		}else if(val == Action.DELETE || val == Action.UNLOCK || val == Action.RESET || val == Action.LOCK || val == Action.SAVE){
			this.takeAction();
		}
	}
	
	public get actionToTake():Action | PreAction {
		return this._actionToTake;
	}
	
	public takeActionFromPreAction():void{ 
		this.actionToTake = Action[this.actionToTake] as Action;
	}
	
	public takeAction():void{
		this.loading = true;
		switch(this.actionToTake){
			case Action.DELETE:
				this.deleteAccount();
				break;
			case Action.UNLOCK:
				this.updateAccountStatus();
				break;
			case Action.LOCK:
				this.updateAccountStatus(false);
				break;
			case Action.RESET:
				this.resetAccountPassword();
				break;
			case Action.SAVE:
				this.updateAccountAsDistrictAdmin();
				break;
		}
		
	}
	
	public deleteAccount():void{
		this.accountUpdateLoading = Action.DELETE;
		this.adminAccountService.deleteAccount(this.districtAccount.accountID).then(res =>{
			this.showModal = false;
			this.accountUpdateLoading = Action.NOOP;
			this.actionToTake = Action.NOOP;
			if(res.data.successfulActions && res.data.successfulActions.length){
				this.davisAlertService.success('Account deleted');
				window.location.replace('/dashboard/accounts');
			}else{
				let msg = res.data.message || 'Account could not be deleted.';
				this.davisAlertService.error(msg);
			}
		}).finally(()=>{
			this.loading = false;
		});
	}
	
	public updateAccountStatus(activeFlag = true):void{
		this.accountUpdateLoading = activeFlag ? Action.UNLOCK : Action.LOCK;
		this.adminAccountService.updateAccountStatus(this.districtAccount.accountID, activeFlag)
			.then(res => {
				if(res.data.successfulActions && res.data.successfulActions.length){
					this.davisAlertService.success('Account Status Updated Successfully');
					this.formObj['status'] = activeFlag ? 'Active' : 'Inactive';
					this.districtAccount['status'] = activeFlag ? 'Active' : 'Inactive';
					if ( activeFlag === false ) {
						this.adminAccountService.getAccountAndLicenseInfo(this.districtAccount['accountID']).then(res => {
							this.assignedLicenses = res.data.data.licenses;
						});
					}
				}else{
					let msg = res.data.message || 'Account status could not be updated.';
					this.davisAlertService.error(msg);
				}
				this.showModal = false;
				this.accountUpdateLoading = Action.NOOP;
				this.actionToTake = Action.NOOP;
			}).finally(()=>{
				this.loading = false;
			});
	}
	
	public resetAccountPassword():void{
		this.accountUpdateLoading = Action.RESET;
		this.adminAccountService.resetAccountPassword(this.districtAccount.accountID).then(res =>{
	
			if(res.data.successfulActions && res.data.successfulActions.length){
				this.davisAlertService.success('Password reset email has been sent.');
			}else{
				let msg = res.data.message || 'The password could not be reset.';
				this.davisAlertService.error(msg);
			}
			this.showModal = false;
			this.accountUpdateLoading = Action.NOOP;
			this.actionToTake = Action.NOOP;
		}).finally(()=>{
			this.loading = false;
		});
	}
	
	public updateAccountAsDistrictAdmin():void{
		
		this.accountUpdateLoading = Action.SAVE;
		this.adminAccountService.updateAccountAsDistrictAdmin(
		this.districtAccount.accountID,
		this.formObj['firstName'],
		this.formObj['lastName'],
		this.formObj['emailAddress'],
		this.formObj['username'],
		this.formObj['accountType']).then(res =>{
	
			if(res.data.successfulActions && res.data.successfulActions.length){
				this.davisAlertService.success('Account has been updated successfully!.');
			}else{
				let msg = res.data.errors || 'There was an unexpected error when updating the Account.';
				this.davisAlertService.error(msg);
			}
			this.showModal = false;
			this.accountUpdateLoading = Action.NOOP;
			this.actionToTake = Action.NOOP;
		}).finally(()=>{
			this.loading = false;
		});
	}
}

export { DistrictUsersController };
